import React, { useEffect, useState } from "react";
import './main_screen.css';
import logo from '../../Assets/logo-app.png'; 
import Menu from '../Menu/menu';
import { useAuth } from '../../Components/Contexts/authContext';
import ProgressCircle from './progressive_circle';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import CloseIcon from '@mui/icons-material/Close';

const MainScreen = () => {
    const [salary, setSalary] = useState(0);
    const [withdrawAmount, setWithdrawAmount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { token,logout } = useAuth();
    const [errorMessage, setErrorMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [popUpMessage, setPopUpMessage] = useState('');
    const [popUpStyle, setPopUpStyle] = useState('');
    
    const handleWithdraw = async () => {
      try {
        const response = await fetch('https://z3tr309yf9.execute-api.us-east-1.amazonaws.com/adelantos', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ amount: withdrawAmount }),
        });
    
        if (response.ok) {
          const data = await response.json();
          setShowMessage(true);
          setPopUpMessage(`El adelanto se ha registrado exitosamente! En menos de 24 hs estará en tu cuenta.`);
          setPopUpStyle('success-popup');
          // Fetch the updated salary
          await fetchSalary();
          
          // Reset the withdraw amount
          setWithdrawAmount(0);
        } else {
          setErrorMessage('Un error a ocurrido. Por favor, intente nuevamente.');
          setPopUpMessage('Un error a ocurrido. Por favor, intente nuevamente.');
          setPopUpStyle('error-popup');
          throw new Error('Error processing withdrawal.');
        }
      } catch (error) {
        console.error('Error:', error);
        setErrorMessage('Error de conexión.');
        setPopUpMessage('Error de conexión.');
        setPopUpStyle('error-popup');
      }
    };

    const fetchSalary = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch('https://z3tr309yf9.execute-api.us-east-1.amazonaws.com/get-user-available-salary', { 
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          setSalary(data.salary); // Asume que el backend devuelve un campo 'salary'
        } else {
          throw new Error('Error al obtener el salario disponible.');
        }
      } catch (error) {
        console.error('Error fetching salary:', error);
        setError('Error al cargar el salario disponible.');
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchSalary();
    }, [token]);
    
    return (
        <div className="main-screen-form-container">
            <header className="flex justify-center w-full">
                <img src={logo} alt="EasyPay Logo" className="main-screen-logo-app" />
            </header>
            <div className="main-screen-content">
              <p className="available-salary-text">Salario Disponible</p>
              {loading ? (
                  <p className="salary-amount">Cargando...</p>
              ) : error ? (
                  <p className="salary-amount error">{error}</p>
              ) : (
                  <p className="salary-amount">{salary} UYU</p>
              )}
              <ProgressCircle availableSalary={salary} maxSalary={salary} withdrawAmount={withdrawAmount} setWithdrawAmount={setWithdrawAmount}/>

              <div className="info-container">
                  <p className="info-text">
                      <span className="info-icon">!</span> Tu sueldo se irá acumulando diariamente
                  </p>
              </div>

              <button className="withdraw-button" onClick={handleWithdraw}>RETIRAR</button>
            </div>
            {popUpMessage && <div className="blur-background"></div>}

            {popUpMessage && (
              <div className={`popup ${popUpStyle}`}>
                <CloseIcon 
                  onClick={() => setPopUpMessage('')} 
                  style={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', color: 'black' }} 
                />
                {popUpStyle === 'success-popup' ? <CheckCircleIcon style={{ fontSize: '2.5em', marginBottom: '10px', color: 'green' }} /> : <ErrorIcon style={{ fontSize: '2.5em', marginBottom: '10px', color: 'white' }} />}
                <p dangerouslySetInnerHTML={{ __html: popUpMessage }}></p>
              </div>
            )}
            <Menu/>
        </div>
    );
};

export default MainScreen;